const React = require('react');
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';


export class ConfirmationModal extends React.Component{
   constructor(props) {
      super(props);
   }

   confirm(){
      this.props.confirmFunction();
      this.props.closeFunction();
   }

   render(){
      return(
         <Dialog
            open={this.props.show}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
         >
            <DialogContent>
               <DialogContentText>
                  {this.props.contentText}
               </DialogContentText>
            </DialogContent>
            <DialogActions>
               <Button onClick={() => this.props.closeFunction()} className={'btnConfirmationModalCancel'} color="primary">
                  Cancel
               </Button>
               <Button onClick={() => this.confirm()} className={'btnConfirmationModalConfirm'} color="primary" autoFocus>
                  {this.props.confirmText}
               </Button>
            </DialogActions>
         </Dialog>
      )
   }
};